import { NavLink } from "react-router-dom";
import { ICONS } from "../utility/common/constants/icons";
const NavItem = ({
  item,
  children,
  counter,
  IsChildopen,
  onHide,
  toggle,
  currentMenu,
}) => {
  let count = counter;
  if (item.menu_children === undefined) count = 0;
  const getIcon = (name, active) => {
    switch (name) {
      case "WPS":
        return active ? ICONS.WPSActive : ICONS.WPSDefault;
      case "PQR":
        return active ? ICONS.PQRActive : ICONS.PQRDefault;
      case "Dashboard":
        return active ? ICONS.DASHBOARDActive : ICONS.DASHBOARDDefault;
      case "Maintenance":
        return active ? ICONS.MaintenanceActive : ICONS.MaintenanceDefault;
      case "Deviation":
        return active ? ICONS.DeviationActive : ICONS.DeviationDefault;
      case "Productivity Measurement":
        return active
          ? ICONS.ProductivityMeasurementActive
          : ICONS.ProductivityMeasurementDefault;
      case "WCS":
        return active ? ICONS.WCSActive : ICONS.WCSDefault;
      case "Welding master": case "Welding Master":
        return active ? ICONS.WeldingMasterActive : ICONS.WeldingMasterDefault;
      case "Welder and Welding Operations":
        return active ? ICONS.OperationsActive : ICONS.OperationsDefault;
      case "WI Transactions":
        return active ? ICONS.WIActive : ICONS.WIDefault;
      case "WPQ":
        return active ? ICONS.WPQActive : ICONS.WPQDefault;
      case "Training":
        return active ? ICONS.TrainingActive : ICONS.TrainingDefault;
    }
  };
  return (
    <div name="menuItem" className="menu-group" key={"MM" + item.menu_id}>
      <div className="menu-side-image">
        <img
          className="menu-icons"
          src={getIcon(item.menu_name, IsChildopen)} //{IsChildopen ? "/sidebar/" + item.menu_name + "_Active.svg" : "/sidebar/" + item.menu_name + "_Default.svg"}
          key={"IMG" + item.menu_id}
          alt=""
        ></img>
      </div>
      <div className="menu-side-name">
        <div className="menu-items" id={"M" + item.menu_id}>
          <NavLink
            to={item.menu_path}
            className={IsChildopen ? "menu-activeitems" : "menu-items"}
            onClick={() => onHide(count, item.menu_path, children)}
          >
            {item.menu_name}
          </NavLink>
        </div>
        <div
          className="nav-children"
          style={{ display: IsChildopen ? "block" : "none" }}
          key={"Child" + item.menu_id + "_" + count}
        >
          {children !== undefined &&
            children.map((c) => (
              <div className="mb-2" key={c.menu_id}>
                <NavLink
                  to={c.menu_path}
                  className="link"
                  onClick={() => toggle()}
                >
                  {c.menu_name}
                </NavLink>
                <br />
              </div>
            ))}
        </div>
      </div>
      <div className="menu-toggle-open">
        {children.length > 0 ? (
          <img
            src={IsChildopen ? ICONS.UpArrow : ICONS.DownArrow}
            className="menu-toggleicon"
            onClick={() => onHide(count, item.menu_path)}
          ></img>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};

export default NavItem;
